export const companyTableOfClusterDetail = {
    multiSort: '*You can sort multiple columns by clicking each header while pressing Shift key.',
    favoriteCompanyList: 'Favourite Company List',
    searchAll: 'Search all',
    userInputPlaceholder: 'Please enter a keyword',
    clusterId: 'Cluster ID',
    companyName: 'Company Name',
    naceCode: 'NACE Code',
    naceLabel: 'NACE Label',
    naceCodeAndLabel: 'Industry Classification (NACE)',
    registeredCountry: 'Registered Country',
    mostFrequentIpc: 'Most Frequent IPC',
    score: 'Score',
    numberOfPatentApplications: 'Number of Patent Applications',
    numberOfMaterialPatents: 'Number of Material Patents',
    materialPatentRate: 'Material Patent rate',
    numberOfForwardCitations: 'Number of Forward Citations',
    revenue: 'Revenue [m USD]',
    minorityInvestmentAmount: 'Minority Investment Amount [m JPY]',
    startup: 'Startup'
}
